// React Imports
import React, { useEffect, useRef, useState } from 'react';
// MUI Imports
import { Box, Button } from '@mui/material';
import { DataGrid, GridToolbarQuickFilter } from '@mui/x-data-grid';

import { reportStore } from 'stores';

function ObjectSettingList({ defaultsOptionEnabled, setDefaultObjectsOn, inSettings }) {
    const [allObjects] = reportStore.useState('allObjects');
    const [currentOrg] = reportStore.useState('currentOrg');
    const [displayedObjects, setDisplayedObjects] = useState(allObjects);
    const [buttonLabel, setButtonLabel] = useState('Show selected');
    const isMounted = useRef(true);
    const [selectedObjects, setSelectedObjects] = reportStore.useState('selectedObjects');
    const [selectedSystemSettings] = reportStore.useState('selectedSystemSettings');
    const [defaultsSelected] = useState(JSON.stringify([...selectedObjects].sort()) === JSON.stringify([...currentOrg.defaultObjects].sort()));
    const [settingsFirstRender] = useState(inSettings && selectedObjects.length === 0);
    const [uarStepperFirstRender] = useState(selectedSystemSettings.length === 0 && selectedObjects.length === 0);

    const columns = [
        {
            field: 'SobjectType',
            headerName: 'Name',
            flex: 1
        }
    ];

    /*
     * useEffect that runs once per render to check whether to use saved selected objects or defaults saved to the account
     */
    useEffect(() => {
        if (defaultsOptionEnabled) {
            //compare currently selected with defaults (if currently selected has values). if they're the same, toggle standard defaults like normal
            const defaultsOn = settingsFirstRender || uarStepperFirstRender || defaultsSelected ? true : false;
            if (defaultsOn) {
                if (isMounted.current) setSelectedObjects(currentOrg.defaultObjects);
            } else {
                if (isMounted.current && !inSettings) {
                    setDefaultObjectsOn(false);
                } else if (isMounted.current) setSelectedObjects(currentOrg.defaultObjects);
            }
        }

        return () => {
            isMounted.current = false;
        };
    }, []);

    const handleSelectRow = (selectedRows) => {
        setSelectedObjects(selectedRows);
        // Clear default toggle off since they're customizing selection
        if (defaultsOptionEnabled && setDefaultObjectsOn) {
            setDefaultObjectsOn(false);
        }
    };

    function Toolbar() {
        return (
            <Box
                sx={{
                    p: 5,
                    display: 'flex',
                    justifyContent: 'space-between'
                }}
            >
                <GridToolbarQuickFilter />
                <Button
                    variant="contained"
                    size="small"
                    onClick={() => {
                        toggleSelected();
                    }}
                >
                    {buttonLabel}
                </Button>
            </Box>
        );
    }

    function toggleSelected() {
        if (buttonLabel === 'Show selected') {
            const display = selectedObjects.reduce((obj, key) => {
                obj[key] = allObjects[key];
                return obj;
            }, {});
            setDisplayedObjects(display);
            setButtonLabel('Show all');
        } else if (buttonLabel === 'Show all') {
            setDisplayedObjects(allObjects);
            setButtonLabel('Show selected');
        }
    }

    return (
        <DataGrid
            getRowId={(row) => row.SobjectType}
            rows={Object.values(displayedObjects)}
            columns={columns}
            sortingOrder={['asc', 'desc']}
            initialState={{
                pagination: {
                    paginationModel: {
                        pageSize: 5
                    }
                },
                sorting: {
                    sortModel: [{ field: 'SobjectType', sort: 'asc' }]
                }
            }}
            pageSizeOptions={[5]}
            checkboxSelection
            onSelectionModelChange={handleSelectRow}
            selectionModel={selectedObjects}
            components={{ Toolbar: Toolbar }}
        />
    );
}

export default ObjectSettingList;
